import Vue from 'vue'
import { keyBy } from 'lodash'
import { setIsLoading } from '@/store/data/common/mutations'

const mutations = {
    /**
     *
     * @param {Object} state - vuex state
     * @param {Object} payload
     * @param {Object[]} payload.taxonomies
     * @param {Number} payload.taxonomies[].id
     * @param {String} payload.taxonomies[].label
     * @param {Object} payload.taxonomies[].segments
     */
    setSharedTaxonomies(state, { taxonomies }) {
        Vue.set(state, 'shared', keyBy(taxonomies, 'id'))
    },

    /**
     *
     * @param {Object} state - vuex state
     * @param {Object} payload
     * @param {String|Number} payload.taxonomyId
     * @param {String} source - Only 'shared' or 'custom' are accepted
     * @param {Object} segments
     */
    setTaxonomySegments(state, { taxonomyId, source, segments }) {
        Vue.set(state[source][taxonomyId], 'segments', keyBy(segments, 'id'))
        Vue.set(state[source][taxonomyId], 'segmentsAlreadyFetched', true)
    },

    /**
     *
     * @param {Object} state - vuex state
     * @param {Object} payload
     * @param {String|Number} payload.taxonomyId
     */
    setSelectedSharedTaxonomie(state, { taxonomyId }) {
        Vue.set(state, 'sharedSelectedId', taxonomyId)
    },

    /**
     *
     * @param {Object} state  -vueX state
     * @param {*} data payload of data to construct the builder with
     */
    setCollection(state, data) {
        Vue.set(state, 'collection', keyBy(data, 'crossId'))
    },

    setIsLoading
}

export default mutations
